export default __webpack_public_path__ + "static/media/4.10cfbc63.png";